// src/composables/useWebSocket.js
import { watch } from 'vue'
import { useUserStore } from '@/store/modules/user'
import { wsService } from '@/utils/websocket'

export function useWebSocket() {
  const userStore = useUserStore()

  const connect = () => {
    if (userStore.token && !wsService.connected) {
      wsService.connect(userStore.token)
    }
  }

  const disconnect = () => {
    wsService.disconnect()
  }

  // 监听token变化，登录后自动连接
  watch(
    () => userStore.token,
    (newToken, oldToken) => {
      if (newToken && !oldToken) {
        // 新登录，连接WebSocket
        connect()
      } else if (!newToken && oldToken) {
        // 登出，断开WebSocket
        disconnect()
      }
    }
  )

  return {
    wsService,
    connect,
    disconnect,
  }
}
